import type { AxiosError } from "axios";

export class ApiError extends Error {
  status?: number;
  code?: string;

  constructor(axiosError: AxiosError) {
    super(axiosError.message);
    this.name = "ApiError";
    this.status = axiosError.response?.status;
    const data = axiosError.response?.data as { message?: string; detail?: string } | undefined;
    this.message = data?.message ?? data?.detail ?? axiosError.message;
    this.code = axiosError.code;
  }
}
